/* eslint-disable @next/next/no-img-element */
import {Button, Modal, ButtonProps} from 'antd';
import useCommon from '@utils/hooks/common';
import styles from './styles';
import classNames from 'classnames';

interface BoxShadowButtonProps extends ButtonProps {
  className?: string;
}

const BoxShadowButton = (props: BoxShadowButtonProps) => {
  const {classes, t} = useCommon({
    withTranslation: null,
    withStyles: styles,
  });

  const {className, children, ...rest} = props;

  return (
    <Button className={classNames(classes.squareButton, className)} {...rest}>
      {children}
    </Button>
  );
};

export default BoxShadowButton;
